import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.offline)?_c(VSystemBar,{attrs:{"app":"","dark":"","color":"error"}},[_c('span',{staticClass:"message"},[_c(VBtn,{attrs:{"small":"","icon":"","text":""}},[_c(VIcon,[_vm._v("mdi-wifi-off")])],1),_vm._v("\n      You don't have an internet connection\n    ")],1)]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }